import type { TFunction } from 'next-i18next';
import type { BedroomCount } from 'domain/listing/value-objects';
import { LOCALE_COMMON_PATHS } from 'types/locales';

export type BedroomCountFormat = 'short' | 'long';

const PLACEHOLDER = '--';

export function formatBedroomCount(bedrooms: BedroomCount, format: BedroomCountFormat, t: TFunction): string {
  if (!bedrooms.hasValue) {
    return PLACEHOLDER;
  }

  const translationKey = format === 'short'
    ? LOCALE_COMMON_PATHS.STATS_BEDROOMS_SHORT
    : LOCALE_COMMON_PATHS.STATS_BEDROOMS_LONG;
  
  return t(translationKey, {
    count: bedrooms.value,
    defaultValue: `${bedrooms.value} ${format === 'short' ? 'bd' : 'Bed'}`,
  });
}
